import React, {Component} from "react";
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import {LayoutSplashScreen} from "../../../../_metronic/layout";
import * as auth from "../_redux/authRedux";

export default function Logout() {

    const {
      user,
      isAuthenticated,
      loginWithRedirect,
      isLoading,
      logout, 
      getIdTokenClaims
    } = useAuth0();
    console.log("Window location", window.location.origin);
    logout({
      returnTo: window.location.origin
    });
    return (
      <LayoutSplashScreen></LayoutSplashScreen>
    );
  }

